import { offlineDatabase } from '../database/offlineDatabase/offlineDatabase';
import { OfflineDatabaseColor } from '../database/offlineDatabase/types/offlineDatabaseColor.types';
import { createOfflineCommonRepository } from './common/createOfflineCommonRepository';
import { createOfflineFilterOptionsRepository } from './filterOptions/createOfflineFilterOptionsRepository';

const commonRepository = createOfflineCommonRepository<OfflineDatabaseColor, 'id'>(
  () => offlineDatabase.colors,
);

const filterOptionsRepository = createOfflineFilterOptionsRepository<OfflineDatabaseColor, 'id'>(
  () => offlineDatabase.colors,
  ['code', 'name'],
);

export const offlineColorsRepository = { ...commonRepository, ...filterOptionsRepository };
